import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { extensionDecorator, NodeExtension, ExtensionTag, isEmptyBlockNode, nodeInputRule, isNodeSelection, invariant, ErrorConstant } from '@remirror/core';
import { TextSelection } from '@remirror/pm/state';

var _dec, _class, _temp;
var HorizontalRuleExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultOptions: {
    insertionNode: 'paragraph'
  }
}), /*#__PURE__*/_dec(_class = (_temp = class HorizontalRuleExtension extends NodeExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "tags", [ExtensionTag.BlockNode]);
  }

  get name() {
    return 'horizontalRule';
  }

  createNodeSpec(extra) {
    return {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'hr',
        getAttrs: extra.parse
      }],
      toDOM: node => ['hr', extra.dom(node)]
    };
  }

  createCommands() {
    return {
      /**
       * Inserts a horizontal line into the editor.
       *
       * @remarks
       *
       * TODO: There is currently a bug in Chrome where if the editor is not
       * focused at the point that this is called, the selection jumps to before
       * the first insertion when you start typing. It doesn't happen in Firefox
       * or Safari.
       */
      insertHorizontalRule: () => parameter => {
        var tr = parameter.tr,
            dispatch = parameter.dispatch;
        var $pos = tr.selection.$anchor;
        var initialParent = $pos.parent;

        if (initialParent.type.name === 'doc' || initialParent.isAtom || initialParent.isLeaf) {
          return false;
        }

        if (!dispatch) {
          return true;
        } // A boolean value that is true when the current node is empty and
        // should be duplicated before the replacement of the current node by
        // the `hr`.


        var shouldDuplicateEmptyNode = tr.selection.empty && isEmptyBlockNode(initialParent); // When the node should eb duplicated add it to the position after
        // before the replacement.

        if (shouldDuplicateEmptyNode) {
          tr.insert($pos.pos + 1, initialParent);
        } // Create the horizontal rule by replacing the selection


        tr.replaceSelectionWith(this.type.create()); // Update the selection if currently pointed at the node.

        this.updateFromNodeSelection(tr);
        dispatch(tr.scrollIntoView());
        return true;
      }
    };
  }

  createInputRules() {
    return [nodeInputRule({
      regexp: /^(?:---|___\s|\*\*\*\s)$/,
      type: this.type,
      beforeDispatch: (_ref) => {
        var tr = _ref.tr;
        // Update to using a text selection.
        this.updateFromNodeSelection(tr);
      }
    })];
  }
  /**
   * Updates the transaction after a `horizontalRule` has been inserted to make
   * sure the currently selected node isn't a Horizontal Rule.
   *
   * This should only be called for empty selections.
   */


  updateFromNodeSelection(tr) {
    // Make sure  the `horizontalRule` that is selected. Otherwise do nothing.
    if (!isNodeSelection(tr.selection) || tr.selection.node.type.name !== this.name) {
      return;
    } // Get the position right after the current selection for inserting the
    // node.


    var pos = tr.selection.$from.pos + 1;
    var insertionNode = this.options.insertionNode; // If `insertionNode` was set to false, then don't insert anything.

    if (!insertionNode) {
      return;
    }

    var type = this.store.schema.nodes[insertionNode];
    !type ? process.env.NODE_ENV !== "production" ? invariant(false, {
      code: ErrorConstant.EXTENSION,
      message: "'".concat(insertionNode, "' node provided as the insertionNode to the '").concat(this.constructorName, "' does not exist.")
    }) : invariant(false) : void 0; // Insert the new node

    var node = type.create();
    tr.insert(pos, node); // Set the new selection to be inside the inserted node.

    tr.setSelection(TextSelection.create(tr.doc, pos + 1));
  }

}, _temp)) || _class);

export { HorizontalRuleExtension };
